import React from 'react';
import styles from './O_CapsulePostMobile.module.css';
import O_CapsulePost from '../O_CapsulePost/O_CapsulePost';
import { MockPost } from '@/mocks';

interface O_CapsulePostMobileProps {
  isOpen: boolean;
  onClose: () => void;
  capsule: MockPost;
  showActionsMenu?: boolean;
  onDelete?: () => void;
  capsuleId?: string;
}

export default function O_CapsulePostMobile({
  isOpen,
  onClose,
  capsule,
  showActionsMenu,
  onDelete,
  capsuleId,
}: O_CapsulePostMobileProps) {
  if (!isOpen) return null;

  return (
    <div className={styles.backdrop} onClick={onClose}>
      <div className={styles.sheet} onClick={e => e.stopPropagation()}>
        <div className={styles.handle} />
        <div className={styles.content}>
          <O_CapsulePost
            capsule={capsule}
            maxWidth='100%'
            showActionsMenu={showActionsMenu}
            onDelete={onDelete}
            capsuleId={capsuleId}
          />
        </div>
      </div>
    </div>
  );
}
